
export * from '../../frontend-taglib-clay/__liferay__/exports/@clayui$card.js';

import __default__ from '../../frontend-taglib-clay/__liferay__/exports/@clayui$card.js';
export default __default__;
